import {Platform, Share} from 'react-native';
import * as Sharing from 'expo-sharing';
export function useShare() {
  const share = async (url: string) => {
    if (Platform.OS === 'ios') {
      Share.share({
        url,
        message: 'Share Media',
      });
      return;
    }
    const isAvailable = await Sharing.isAvailableAsync();
    console.info('isSharingAvailable', isAvailable, url);
    const sh = await Sharing.shareAsync('file://' + url, {
      dialogTitle: 'Export File',
      mimeType: 'video/mp4',
    });
    console.info('sh result', sh);
  };
  return {share};
}
